import { action, makeObservable, observable } from 'mobx';

class GameStore {
  incrementFixNumberTimeOutId1 = null;

  incrementFixNumberTimeOutId2 = null;

  isBetsClosed = false;

  numPadData = { isOpen: false, sectionName: null, currentInputValue: null };

  timerDuration = 10;

  finishedResult = null;

  isAnim = false;

  fixNumber = null;

  rangeRunFullCount = 1;

  pastRoundsData = [];

  minOddOverTaken = null;

  margin = null;

  isRoundFin = false;

  isLoadingPage = false;

  isPongReceived = false;

  animationTime = null;

  gameState = {
    status: '',
    isInitialLoaded: false,
  };

  constructor() {
    makeObservable(this, {
      gameState: observable,
      finishedResult: observable,
      numPadData: observable.deep,
      pastRoundsData: observable.deep,
      isBetsClosed: observable,
      isPongReceived: observable,
      animationTime: observable,
      minOddOverTaken: observable,
      rangeRunFullCount: observable,
      fixNumber: observable,
      isLoadingPage: observable,
      margin: observable,
      isAnim: observable,
      isRoundFin: observable,
      timerDuration: observable,
      setGameState: action.bound,
      setNumPadData: action.bound,
      setIsAnim: action.bound,
      setFinishedResult: action.bound,
      setIsBetsClosed: action.bound,
      setMargin: action.bound,
      setFixNumber: action.bound,
      resetRangeRunFullCount: action.bound,
      incrementFixNumber: action.bound,
      setMinOddOverTaken: action.bound,
      setIsLoadingPage: action.bound,
      setIsRoundFin: action.bound,
      setAnimationTime: action.bound,
      setPastRoundsData: action.bound,
      setTimerDuration: action.bound,
      setIsPongReceived: action.bound,
    });
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  setAnimationTime(animationTime) {
    this.animationTime = animationTime;
  }

  resetRangeRunFullCount() {
    this.rangeRunFullCount = 1;
  }

  setFixNumber(fixNumber, withRangeReset) {
    this.fixNumber = fixNumber;
    if (withRangeReset) {
      this.resetRangeRunFullCount();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  incrementFixNumber(winNumber) {
    // eslint-disable-next-line no-nested-ternary
    const time = winNumber < 14 ? 200 : winNumber < 20 ? 400 : 500;
    // eslint-disable-next-line no-nested-ternary
    const secondTime = winNumber < 14 ? 50 : winNumber < 20 ? 40 : 30;

    if (this.rangeRunFullCount <= 2) {
      this.incrementFixNumberTimeOutId1 = setTimeout(() => {
        if (this.fixNumber <= 30) {
          this.setFixNumber(this.fixNumber + 1);
          this.incrementFixNumber(winNumber);
        } else {
          this.setFixNumber(5);
          this.rangeRunFullCount += 1;
          this.incrementFixNumber(winNumber);
        }
      }, secondTime);
    } else {
      this.incrementFixNumberTimeOutId2 = setTimeout(() => {
        if (this.fixNumber + 1 <= winNumber) {
          this.setFixNumber(this.fixNumber + 1);
          this.incrementFixNumber(winNumber);
        }
      }, time / (winNumber - this.fixNumber));
    }
  }

  // statistics
  setNumPadData(data) {
    this.numPadData = data;
  }

  setFinishedResult(result) {
    this.finishedResult = result;
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setIsAnim(isAnim) {
    this.isAnim = isAnim;
  }

  setIsRoundFin(boolean) {
    this.isRoundFin = boolean;
  }

  setGameState(status) {
    this.gameState = status;
  }

  setMargin(margin) {
    this.margin = margin;
  }

  setMinOddOverTaken(boolean) {
    this.minOddOverTaken = boolean;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setIsLoadingPage(isLoadingPage) {
    this.isLoadingPage = isLoadingPage;
  }

  setPastRoundsData(data) {
    if (data.length) {
      this.pastRoundsData = data;
    } else {
      this.pastRoundsData = [data, ...this.pastRoundsData];
    }
  }
}

export const gameStore = new GameStore();
